// ============================================================
// BEEP-OS — TOKENS DE DISENO (helper JS para estilos en linea)
// Solo re-exporta las CSS vars como strings. NO duplica hex.
// Uso: style={{ color: tokens.primary, background: tokens.surface }}
// La fuente de verdad de los valores esta en styles/tokens.css
// ============================================================
export const tokens = {
  // Marca / primario
  primary:        'var(--color-primary)',
  primaryHover:   'var(--color-primary-hover)',
  primaryActive:  'var(--color-primary-active)',
  accent:         'var(--color-accent)',
  primarySoft:    'var(--color-primary-soft)',
  primary100:     'var(--color-primary-100)',
  // Superficie
  bg:             'var(--color-bg)',
  surface:        'var(--color-surface)',
  surfaceSubtle:  'var(--color-surface-subtle)',
  // Texto
  text:           'var(--color-text)',
  textSecondary:  'var(--color-text-secondary)',
  textMuted:      'var(--color-text-muted)',
  textOnPrimary:  'var(--color-text-on-primary)',
  // Bordes
  borderSubtle:   'var(--color-border-subtle)',
  border:         'var(--color-border)',
  borderStrong:   'var(--color-border-strong)',
  borderFocus:    'var(--color-border-focus)',
  // Estados
  success:        'var(--color-success)',
  danger:         'var(--color-danger)',
  warning:        'var(--color-warning)',
  successSoft:    'var(--color-success-soft)',
  warningSoft:    'var(--color-warning-soft)',
  dangerSoft:     'var(--color-danger-soft)',
};
export const palette = {
  blue: { 950:'var(--blue-950)',900:'var(--blue-900)',800:'var(--blue-800)',700:'var(--blue-700)',600:'var(--blue-600)',500:'var(--blue-500)',400:'var(--blue-400)',300:'var(--blue-300)',200:'var(--blue-200)',100:'var(--blue-100)',50:'var(--blue-50)' },
  gray: { 950:'var(--gray-950)',900:'var(--gray-900)',800:'var(--gray-800)',700:'var(--gray-700)',600:'var(--gray-600)',500:'var(--gray-500)',400:'var(--gray-400)',300:'var(--gray-300)',200:'var(--gray-200)',100:'var(--gray-100)',50:'var(--gray-50)' },
};
export default tokens;
